import React, { useRef, useLayoutEffect, useState } from 'react'
import { concatStrings } from '../utilities'

const PartnerItem = (props) => {
  const { premium, partner, big, ultra, multiplePremium, partnerLength } = props

  const Link = partner.url ? 'a' : 'span'
  const linkProps = partner.url
    ? {
      href: partner.url,
      target: '_blank',
      rel: 'noopener noreferrer',
    }
    : {}

  let styling = {}
  if (ultra) {
    styling = {
      width: '92px',
      height: '92px'
    }
  } else if (premium) {
    styling = {
      width: '72px',
      height: '72px'
    }
  }
  return (
    <li
      className={concatStrings(
        'c-PartnerSlider-item',
        big ? 'c-PartnerSlider-item--big' : premium ? 'c-PartnerSlider-item--premium' : multiplePremium ? 'c-PartnerSlider-item--small' : '',
        !premium && partnerLength <= 1 && 'c-PartnerSlider-item--center'
      )}
      style={styling}
      data-testid="partner-slider-item"
    >
      <Link className={concatStrings('c-PartnerSlider-link', premium && 'c-PartnerSlider-link--premium')} {...linkProps}>
        <img
          className={'dfb-Symbol c-PartnerSlider-logo'}
          alt={partner.title || partner.logo}
          src={`/images/sponsoring/${partner.logo}_01.png`}
          loading="lazy"
        />
      </Link>
    </li>
  )
}
function CPartnerSlider({ data }) {
  const [partnerSliderWidth, setPartnerSliderWidth] = useState()
  const partnerSliderRef = useRef(null)
  // filter out partners without a logo
  const filteredPartners = data?.partners.filter((item) => item.logo !== 'none')
  // double the partner to create a seamless loop

  const partnerSliderListWidth = filteredPartners.length * (64 + 40)
  const isAnimated = partnerSliderListWidth > partnerSliderWidth

  // double the partners to create a seamless loop
  const marqueePartners = isAnimated ? filteredPartners.concat(filteredPartners) : filteredPartners

  useLayoutEffect(() => {
    if (!partnerSliderRef.current) {
      return
    }

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setPartnerSliderWidth(entry.contentRect.width)
      }
    })

    observer.observe(partnerSliderRef.current)

    return () => {
      observer.disconnect()
    }
  }, [])

  const filteredUltraPremiumPartners = data?.premiumPartners.filter((item) => item.logo !== 'none' && item.ultra)

  const filteredPremiumPartners = data?.premiumPartners.filter((item) => item.logo !== 'none' && !filteredUltraPremiumPartners.includes(item))

  return (
    <div
      ref={partnerSliderRef}
      className={`c-PartnerSlider c-PartnerSlider--dark ${filteredPremiumPartners.length > 4 ? 'c-PartnerSlider--multiple-premium' : filteredPremiumPartners.length === 4 ? 'c-PartnerSlider--multiple-premium c-PartnerSlider--multiple-premium-double' : ''}`}
      data-testid="partner-slider"
      style={{paddingBottom: '0', height: '280px'}}
    >
      {data.headline && <h2 className="c-PartnerSlider-headline" data-testid="partner-slider-headline">{data.headline}</h2>}
      {filteredUltraPremiumPartners?.length > 0 && (
        <ul
          className="c-PartnerSlider-list c-PartnerSlider-list--premium"
          style={{
            'margin-bottom': `${filteredPremiumPartners.length > 0 ? 0.5 : marqueePartners.length === 1 ? 0 : 8}rem`,
          }}
          data-testid="partner-slider-list-premium"
        >
          {filteredUltraPremiumPartners?.map((partner, index) => <PartnerItem partner={partner} key={index} premium ultra={true} big={false} />)}
        </ul>
      )}
      <ul
        className="c-PartnerSlider-list c-PartnerSlider-list--premium"
        style={{
          'margin-bottom': `${filteredPremiumPartners.length > 0 ? 0.5 : marqueePartners.length === 1 ? 0 : 8}rem`,
        }}
        data-testid="partner-slider-list-premium"
      >
        {filteredPremiumPartners.length > 0 &&
          filteredPremiumPartners?.map((partner, index) => <PartnerItem partner={partner} premium key={index} big={filteredPremiumPartners.length === 1 && !marqueePartners.length} />)}
      </ul>
      {marqueePartners.length > 0 && (
        <ul
          className={concatStrings('c-PartnerSlider-list', isAnimated && 'c-PartnerSlider-list--animated')}
          style={{
            '--item-count': marqueePartners?.length,
            'animation-duration': `${marqueePartners?.length}s`,
          }}
          data-testid="partner-slider-list"
        >
          {marqueePartners?.map((partner, index) => (
            <PartnerItem
              partner={partner}
              partnerLength={filteredPartners.length}
              multiplePremium={filteredPremiumPartners.length > 3}
              key={index}
              big={!filteredPremiumPartners.length && marqueePartners.length === 1}
            />
          ))}
        </ul>
      )}
    </div>
  )
}

export default CPartnerSlider
